var map = {
	"./ackee.svg": 2288,
	"./apple.svg": 3277,
	"./apricot.svg": 9175,
	"./avocado.svg": 4266,
	"./bael.svg": 7055,
	"./banana.svg": 2592,
	"./blackberry.svg": 2308,
	"./blueberry.svg": 7253,
	"./breadfruit.svg": 9179,
	"./carambola.svg": 2877,
	"./cempedak.svg": 5619,
	"./cherimoya.svg": 7826,
	"./cherry.svg": 1784,
	"./coconut.svg": 1996,
	"./cranberry.svg": 939,
	"./cupuacu.svg": 8503,
	"./currant.svg": 4386,
	"./date.svg": 7619,
	"./dragonfruit.svg": 20,
	"./durian.svg": 4464,
	"./feijoa.svg": 4009,
	"./fig.svg": 9407,
	"./gooseberry.svg": 2520,
	"./grape.svg": 3280,
	"./jabuticaba.svg": 4721,
	"./jackfruit.svg": 608,
	"./kiwano.svg": 3362,
	"./kiwi.svg": 1571,
	"./langsat.svg": 4581,
	"./lemon.svg": 4816,
	"./longan.svg": 680,
	"./longkong.svg": 7422,
	"./loquat.svg": 9441,
	"./lucuma.svg": 6940,
	"./lychee.svg": 9821,
	"./mango.svg": 6687,
	"./mangosteen.svg": 6470,
	"./medlar.svg": 6104,
	"./melon.svg": 3292,
	"./miraclefruit.svg": 4466,
	"./mulberry.svg": 4937,
	"./mulberryfig.svg": 8069,
	"./noni.svg": 4125,
	"./olive.svg": 9724,
	"./orange.svg": 1097,
	"./papaya.svg": 5045,
	"./passionfruit.svg": 4804,
	"./pawpaw.svg": 7659,
	"./peach.svg": 6930,
	"./pear.svg": 6951,
	"./persimmon.svg": 9817,
	"./physalis.svg": 7528,
	"./pineapple.svg": 6715,
	"./pitaya.svg": 705,
	"./plum.svg": 2185,
	"./pomegranate.svg": 9064,
	"./pomelo.svg": 321,
	"./pulasan.svg": 2655,
	"./rambutan.svg": 1647,
	"./raspberry.svg": 187,
	"./redcurrant.svg": 5567,
	"./safou.svg": 4659,
	"./salak.svg": 1217,
	"./santol.svg": 136,
	"./santolfig.svg": 1254,
	"./sapodilla.svg": 6162,
	"./soursop.svg": 5342,
	"./soursopfig.svg": 4232,
	"./starfruit.svg": 9559,
	"./strawberry.svg": 9308,
	"./sugarapple.svg": 5533,
	"./sugarfig.svg": 2831,
	"./sweetsop.svg": 1777,
	"./tamarillo.svg": 8274,
	"./tamarind.svg": 3013,
	"./tangelo.svg": 3555,
	"./tangerine.svg": 8956,
	"./ugli.svg": 4930,
	"./watermelon.svg": 2661,
	"./whitecurrant.svg": 4273,
	"./yumberry.svg": 4934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6869;